import React from "react";
import { Header } from "@/components/Header";

export function SmsTermsPage() {
  return (
    <LegalShell title="SMS Messaging Terms & Conditions" updated="June 2026">
      <p>CareBed (operated via carebednav.com) offers an SMS program to help facility directors keep their bed-availability information current.</p>
      <h2>1. Program description</h2>
      <p>By providing your mobile number and checking the consent box at sign-up, you agree to receive recurring automated text messages from CareBed, including requests to confirm or update the number of beds available at your facility, and related account notifications.</p>
      <h2>2. Consent is not a condition of purchase</h2>
      <p>You are not required to agree to receive text messages as a condition of creating an account, claiming a listing, or purchasing any plan or service.</p>
      <h2>3. Message frequency &amp; cost</h2>
      <p>Message frequency varies based on facility activity. Message and data rates may apply, charged by your wireless carrier. CareBed does not charge for the messages themselves.</p>
      <h2>4. Opting out</h2>
      <p>You can cancel the SMS service at any time by replying <b>STOP</b> to any message. After you send <b>STOP</b>, we will send a confirmation message and then stop sending SMS messages. To rejoin, sign up again as you did the first time.</p>
      <h2>5. Help</h2>
      <p>Reply <b>HELP</b> to any message for assistance, or email support@carebednav.com.</p>
      <h2>6. Supported carriers &amp; delivery</h2>
      <p>Carriers are not liable for delayed or undelivered messages. Delivery is subject to effective transmission by your carrier.</p>
      <h2>7. Privacy</h2>
      <p>Your mobile information is handled in accordance with our Privacy Policy and is never sold or shared with third parties for their marketing purposes.</p>
    </LegalShell>
  );
}

export function PrivacyPage() {
  return (
    <LegalShell title="Privacy Policy" updated="June 2026">
      <p>This Privacy Policy explains how CareBed collects, uses, and protects your information.</p>
      <h2>Information we collect</h2>
      <p>Account details (name, email, role), facility details, mobile phone number (if provided), inquiries you submit, and payment records processed by our payment provider.</p>
      <h2>How we use information</h2>
      <p>To operate the marketplace, route inquiries to facilities, send transactional and (with consent) SMS messages, process upgrades and concierge orders, and improve the service.</p>
      <h2>SMS data</h2>
      <p>Mobile numbers collected for SMS are used only to deliver the messages you opted into. We do not sell or share mobile opt-in data or consent with third parties for marketing.</p>
      <h2>Your choices</h2>
      <p>You can opt out of SMS by replying STOP, and you may request deletion of your account by emailing support@carebednav.com.</p>
      <h2>Contact</h2>
      <p>Questions? Email support@carebednav.com.</p>
    </LegalShell>
  );
}

function LegalShell({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-[#F7F6F2]">
      <Header />
      <div className="max-w-[760px] mx-auto px-4 md:px-8 py-12">
        <h1 className="font-heading text-4xl font-medium tracking-tight text-[#1C211F] mb-2">{title}</h1>
        <p className="text-sm text-[#5C6660] mb-8">Last updated: {updated}</p>
        <div className="prose-blog text-[#2A312D]">{children}</div>
      </div>
    </div>
  );
}
